import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'

import demoApp from './reducers'
import dataSaga from './sagas'
import App from './App'

import './index.css'

const sagaMiddlware = createSagaMiddleware()
const store = createStore(
  demoApp,
  applyMiddleware(sagaMiddlware)
)

sagaMiddlware.run(dataSaga)

store.dispatch({ type: 'FETCH_DATA' })

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js